import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import * as PIXI from "pixi.js";
import {SpinePlayer} from "../../core/displayObject/SpinePlayer";
import {KarenLayers, Layers} from "../view/KarenLayers";
import {IDimOrientation, LayoutDimData, ResizeHelper} from "../../core/utils/ResizeHelper";

export class KarenIntroView extends PIXI.Container {
    private _introAnim: SpinePlayer;
    private _gfxBg: PIXI.Graphics;
    private tlBg: TimelineMax;
    private layoutDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 360),
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 360)
        }
    };

    constructor() {
        super();
        this.createGraphic();
        this.onResize();
        this.sortChildren();
        this.visible = false;
        KarenLayers.getLayer(Layers.INTRO_VIEW)!.addChild(this);
    }

    public playIntroAnimation(callBackFunc: Function): TimelineLite {
        this._introAnim = this.addChild(new SpinePlayer("intro"));
        this._introAnim.position.set(0, 0);
        const animPathName: string = this._introAnim.spine.spineData.animations[0].name;
         const tl: TimelineLite = new TimelineLite();
         tl.add( this._introAnim.play({name:"Intro2"}));
        this.interactive = true;
        this.visible = true;
        this._gfxBg.alpha = 0;
        this.setBGAlpha(0.8, 0.25);

        this.on('pointerdown', () => {
            TweenLite.to(this._introAnim, {duration: 0.25, alpha: 0});
            this.interactive = false;
            this.setBGAlpha(0, 0.25);
            callBackFunc();
        });

        tl.add([
            TweenLite.to(this._introAnim, {duration: 0.25, alpha: 0}),
            () => {this.setBGAlpha(0, 0.25)}
        ], "-=0.25");
        return tl;
    }

    public setBGAlpha(alpha: number, durr: number) {
        this.tlBg = new TimelineMax({
            onStart: () => {
                this.visible = true;
            },
            onComplete: () => {this.visible = !!this._gfxBg.alpha}
        });
        this.tlBg.to(this._gfxBg, {alpha: alpha, duration: durr});
        return this.tlBg;
    }

    public onResize(): void {
        const rezDim: LayoutDimData = ResizeHelper.calcDim(this.layoutDim)
        this.position = rezDim.position;
        this.scale = rezDim.scale;
    }

    protected createGraphic(): void {
        const maxAreaSize: number = 3000;
        this._gfxBg = this.addChild(new PIXI.Graphics());
        this._gfxBg.beginFill(0x000000, 0.65);
        this._gfxBg.drawRect(-maxAreaSize * 0.5, -maxAreaSize * 0.5, maxAreaSize, maxAreaSize);
        this._gfxBg.endFill();
    }
}
